// extracted by mini-css-extract-plugin
export default {"title":"BloggerPhotoAi_title__BfpdH","content":"BloggerPhotoAi_content__mnbNd"};